export default "/assets/images/icon-support.svg?091595240950e5aaefc2f64aa9188d7f";